/* hs-eslint ignored failing-rules */

import { PureComponent } from 'react';
import { connect } from 'react-redux';
import Raven from 'raven-js';
import I18n from 'I18n';
// Needed for GDPR select.
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/publicLocales';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { debounce, isEqual } from 'underscore';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { FormsLangToLang } from 'ContentData/utils/forms';
import FieldGroup from 'ContentComponents/components/cmv2/fields/FieldGroup';
import FormResponse from 'ContentComponents/components/cmv2/form/FormResponse';
import { ASYNC_SELECTOR_DEBOUNCE } from 'ContentComponents/components/cmv2/constants';
import FormSaveIndicator from 'ContentComponents/components/cmv2/form/FormSaveIndicator';
import FormAutomation from 'ContentComponents/components/cmv2/form/formAutomation/FormAutomation';
import FormFieldEditor from './FormFieldEditor';
import FormContent from './formContent/FormContent';
import FormSelectorSelect from './FormSelectorSelect';
import FormActionsDropdown from './FormActionsDropdown';
import CreateFormButton from './CreateFormButton';
import PagesModal from './PagesModal';
import PagesSidePanelContainer from './PagesSidePanel';
import CreateFormWithNameModal from './CreateFormWithNameModal';
import MarketingContactsWarning from './MarketingContactsWarning';
import FormAutomationFieldGroup from 'ContentComponents/components/cmv2/form/formAutomation/FormAutomationFieldGroup';
import getLegalConsentCopy from 'forms-utils-lib/api/legalConsent/getLegalConsentCopy';
import buildLegalConsent from 'forms-utils-lib/legalConsent/buildLegalConsent';
import { View } from 'foundations-components/components/View';
import * as FormsActions from 'ContentData/actions/Forms';
import * as formsSelectors from 'ContentData/selectors/forms';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const mapStateToProps = (state, props) => {
  const formGuid = typeof props.value === 'object' ? props.value.form_id : props.value;
  const selectedForm = formsSelectors.getDraftForm(state, {
    formGuid: formGuid
  });
  return Object.assign({}, props, {
    selectedForm,
    subscriptions: formsSelectors.getSubscriptions(state),
    consentCopy: formsSelectors.getConsentCopy(state, selectedForm),
    shouldShowPagesModal: formsSelectors.getShouldShowPagesModal(state, {
      formGuid: formGuid
    })
  });
};
const mapDispatchToProps = {
  fetchDraftForm: FormsActions.fetchDraftForm,
  fetchProperties: FormsActions.fetchContactProperties,
  fetchSubscriptions: FormsActions.fetchSubscriptionDefinitions,
  fetchDefaultConsentCopy: FormsActions.fetchDefaultConsentCopy,
  saveForm: FormsActions.saveFormDraft,
  updateFormDraft: FormsActions.updateFormDraft,
  fetchParentPages: FormsActions.fetchParentPages
};
const connector = connect(mapStateToProps, mapDispatchToProps);
const formI18nKey = key => `ContentComponents.cmv2.fields.form.${key}`;
const inlineEditingI18nKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.${key}`;
const i18nKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.createForm.withNameModal.${key}`;
const FormExpandableSection = ({
  children,
  flush,
  label,
  open,
  onOpenChange,
  useOnDark,
  ['data-selenium']: seleniumKey
}) => {
  return /*#__PURE__*/_jsx(FieldGroup, {
    containsNestedGroups: false,
    fieldGroupOpen: open,
    fieldKey: [seleniumKey],
    onFieldGroupOpenChange: onOpenChange,
    onFieldReset: () => {},
    label: label,
    stretchToSides: !flush,
    useOnDark: useOnDark,
    withContentPadding: true,
    children: children
  });
};
export const NoFormsWriteScopeMessage = () => /*#__PURE__*/_jsx(Alert, {
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: formI18nKey('noFormsWrite.title')
  }),
  type: "warning",
  marginBlockEnd: "200",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: formI18nKey('noFormsWrite.body')
  })
});
class FormWithInlineEditing extends PureComponent {
  constructor(props) {
    super(props);
    const {
      FormDefinition,
      loadOptions,
      selectedForm
    } = props;
    this.onFormContentOpenChange = this.onFormContentOpenChange.bind(this);
    this.onThankYouOpenChange = this.onThankYouOpenChange.bind(this);
    this.onShowPagesStateChange = this.onShowPagesStateChange.bind(this);
    this.flushQueuedFormDefinition = this.flushQueuedFormDefinition.bind(this);
    this.showFormCreateModal = this.showFormCreateModal.bind(this);
    this.hideFormCreateModal = this.hideFormCreateModal.bind(this);
    this.setFormCreateConflictError = this.setFormCreateConflictError.bind(this);
    this.handleCreateForm = this.handleCreateForm.bind(this);
    this.onEditField = this.onEditField.bind(this);
    this.handleCloneForm = this.handleCloneForm.bind(this);
    this.toggleFormCloneModal = this.toggleFormCloneModal.bind(this);
    this.toggleClonePendingStatus = this.toggleClonePendingStatus.bind(this);
    this.handleGdprValueChange = this.handleGdprValueChange.bind(this);
    this.debouncedLoadOptions = debounce(loadOptions, ASYNC_SELECTOR_DEBOUNCE);
    this.state = {
      pagesSidePanelOpen: false,
      isShowingFormCreateModal: false,
      isCreateFormConflictError: false,
      selectedFieldId: null,
      formContentOpen: false,
      thankYouOpen: false,
      hasIntendedToEdit: false,
      isShowingFormCloneModal: false,
      isClonePending: false,
      currentGuid: null,
      formDefinition: FormDefinition && selectedForm ? new FormDefinition(selectedForm) : undefined
    };
  }
  componentDidMount() {
    const {
      fetchDraftForm,
      fetchProperties,
      fetchSubscriptions,
      fetchDefaultConsentCopy,
      fetchConsentCopyFn,
      fetchParentPages
    } = this.props;
    if (this.formGuid) {
      fetchDraftForm(this.formGuid).catch(err => {
        setTimeout(() => {
          throw err;
        });
      });
      fetchParentPages(this.formGuid);
      fetchProperties().catch(err => {
        setTimeout(() => {
          throw err;
        });
      });
      fetchSubscriptions().catch(err => {
        setTimeout(() => {
          throw err;
        });
      });
      if (fetchConsentCopyFn) {
        fetchDefaultConsentCopy(fetchConsentCopyFn).catch(err => {
          setTimeout(() => {
            throw err;
          });
        });
      }
    }
  }
  componentDidUpdate(prevProps) {
    const {
      FormDefinition
    } = this.props;

    // If this field was previously focused but is now no longer focused,
    // we are exiting the form field editing experience
    if (isEqual(prevProps.currentFieldKey, this.props.fieldKey) && !isEqual(this.props.currentFieldKey, this.props.fieldKey)) {
      this.setState({
        selectedFieldId: null,
        formContentOpen: true
      });
    }
    if (!isEqual(prevProps.selectedForm, this.props.selectedForm)) {
      const {
        guid: previousFormGuid
      } = prevProps.selectedForm || {};
      const {
        guid: currentFormGuid
      } = this.props.selectedForm || {};
      this.setState(Object.assign({
        formDefinition: new FormDefinition(this.props.selectedForm)
      }, previousFormGuid !== currentFormGuid ? {
        formContentOpen: true
      } : {}));
    }
  }
  get fieldKey() {
    const {
      fieldKey
    } = this.props;
    return fieldKey && fieldKey.join('.');
  }
  get formGuid() {
    const {
      value
    } = this.props;
    if (!value) return null;
    if (typeof value === 'object') {
      return value.form_id || null;
    }
    return value;
  }
  showFormCreateModal() {
    this.setState({
      isShowingFormCreateModal: true,
      isCreateFormConflictError: false
    });
  }
  hideFormCreateModal() {
    this.setState({
      isShowingFormCreateModal: false,
      isCreateFormConflictError: false
    });
  }
  setFormCreateConflictError() {
    this.setState({
      isCreateFormConflictError: true
    });
  }
  toggleFormCloneModal(guid = null) {
    this.setState({
      isShowingFormCloneModal: !this.state.isShowingFormCloneModal,
      currentGuid: guid
    });
  }
  getShouldPromptPagesModal() {
    const {
      shouldShowPagesModal
    } = this.props;
    const {
      hasIntendedToEdit
    } = this.state;
    return hasIntendedToEdit && shouldShowPagesModal;
  }
  onFormContentOpenChange(isOpen) {
    this.setState({
      formContentOpen: isOpen
    });
  }
  onThankYouOpenChange(isOpen) {
    this.setState({
      thankYouOpen: isOpen
    });
  }
  onShowPagesStateChange() {
    this.setState({
      pagesSidePanelOpen: !this.state.pagesSidePanelOpen
    });
  }
  onEditField(selectedFieldId) {
    this.props.setFieldKey(this.props.fieldKey);
    this.props.onOpenEditFieldPanelEvent();
    this.setState({
      hasIntendedToEdit: true,
      selectedFieldId
    });
  }
  toggleClonePendingStatus() {
    this.setState({
      isClonePending: !this.state.isClonePending
    });
  }
  handleCreateForm(name) {
    const {
      createFormFn
    } = this.props;
    createFormFn(name, {
      shouldRedirect: false,
      onSuccess: this.hideFormCreateModal,
      onConflictError: this.setFormCreateConflictError
    });
  }
  handleCloneForm(name) {
    const {
      cloneFormFn
    } = this.props;
    this.toggleClonePendingStatus();
    cloneFormFn(this.state.currentGuid, name).then(({
      guid
    }) => this.props.onFormChange({
      target: {
        value: guid
      }
    })).catch(err => console.error(err)).finally(() => {
      this.toggleFormCloneModal();
      this.toggleClonePendingStatus();
    });
  }
  handleGdprValueChange(consentType) {
    const {
      subscriptions,
      onGdprChangeEvent
    } = this.props;
    const {
      formDefinition
    } = this.state;
    const {
      metaData,
      businessUnitId
    } = formDefinition;
    const formLanguage = metaData.find(i => i.name === 'lang').value;
    const language = FormsLangToLang[formLanguage] || formLanguage;
    onGdprChangeEvent();
    getLegalConsentCopy({
      language,
      businessUnitId
    }).then(legalConsentCopy => {
      const updatedLegaConsent = buildLegalConsent({
        legalConsentOption: consentType,
        legalConsentCopy,
        subscriptionDefinitions: subscriptions
      });
      this.updateForm(formDefinition.updateMetaDataValue('legalConsentOptions', updatedLegaConsent));
    }).catch(err => {
      Raven.captureMessage('Failed to update Form GDPR value', err);
    });
  }
  flushQueuedFormDefinition() {
    const {
      queuedFormDefinition
    } = this.state;
    if (queuedFormDefinition) {
      this.setState({
        queuedFormDefinition: null
      });
      this.updateForm(queuedFormDefinition);
    }
  }
  updateForm(formDefinition) {
    const {
      shouldShowPagesModal,
      updatePreview,
      hasFormsWriteAccess
    } = this.props;
    const {
      hasIntendedToEdit
    } = this.state;
    if (!hasFormsWriteAccess) {
      return;
    }
    if (shouldShowPagesModal && !hasIntendedToEdit) {
      this.setState({
        hasIntendedToEdit: true,
        queuedFormDefinition: formDefinition
      });
      return;
    }
    const definition = formDefinition.toJS();
    this.props.updateFormDraft(definition, updatePreview);
  }
  maybeRenderPagesModal() {
    const {
      onFormChange
    } = this.props;
    return this.getShouldPromptPagesModal() ? /*#__PURE__*/_jsx(PagesModal, {
      onFormChange: onFormChange,
      formGuid: this.formGuid,
      onClose: this.flushQueuedFormDefinition
    }) : null;
  }
  renderResponse() {
    const {
      componentsByType,
      fieldKey,
      onFieldChange,
      readOnly,
      useOnDark,
      value
    } = this.props;
    return /*#__PURE__*/_jsxs(View, {
      marginBlockStart: "500",
      as: "div",
      children: [/*#__PURE__*/_jsx(Alert, {
        type: "info",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: inlineEditingI18nKey('thankYou.pageOnlyNote')
        })
      }), /*#__PURE__*/_jsx(FormResponse, {
        componentsByType: componentsByType,
        fieldKey: fieldKey,
        onFieldChange: onFieldChange,
        readOnly: readOnly,
        useOnDark: useOnDark,
        value: value,
        hasFormsWriteAccess: true
      })]
    });
  }
  renderSelectedField() {
    const {
      useOnDark,
      openFormFn,
      hasFormsWriteAccess,
      maybeRenderInlineEditingOptIn
    } = this.props;
    const {
      selectedFieldId,
      formDefinition
    } = this.state;
    const field = this.state.formDefinition.getFormFieldById(selectedFieldId);
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [hasFormsWriteAccess ? maybeRenderInlineEditingOptIn(field.objectTypeId, field.name) : /*#__PURE__*/_jsx(NoFormsWriteScopeMessage, {}), /*#__PURE__*/_jsxs("div", {
        children: [this.maybeRenderPagesModal(), /*#__PURE__*/_jsx(FormSaveIndicator, {
          form: formDefinition
        }), /*#__PURE__*/_jsx(FormFieldEditor, {
          field: field,
          useOnDark: useOnDark,
          openFormFn: openFormFn,
          onChange: newField => {
            this.updateForm(this.state.formDefinition.updateFormField(newField));
          }
        })]
      })]
    });
  }
  renderAccordions() {
    const {
      value,
      useOnDark,
      flush,
      hasAutomatedEmailEditorAccess,
      hasEmailMarketingAccess,
      hasInlineEmailEditorAccess,
      hasWorkflowsAccess,
      hasWorkflowsAppAccess,
      hasWorkflowsDeleteAccess,
      hasWorkflowsWriteAccess,
      isFreePortal,
      legacyFollowupEmailId,
      clearLegacyFollowupEmail,
      DraggableComponents,
      consentCopy,
      hasMarketingContactsAccess,
      hasMarketingContactsPermissions,
      allowFormEditingDnd,
      openFormFn,
      onAutomationChange,
      hasFormsWriteAccess,
      onIsCreatingMarketingContactsChange,
      readOnly,
      contentId,
      onAddWorkflowEvent,
      onEditWorkflowEvent,
      onRemoveWorkflowEvent,
      onChangeFollowupEmailEvent,
      onFollowupEmailIdChange,
      followupEmailSelectedForForm,
      webinarSelect,
      formAutomationOpen,
      onFormAutomationOpenChange,
      scrollToFollowupEmail,
      willScrollAfterRemount,
      resetWillScrollAfterRemount
    } = this.props;
    const {
      formDefinition
    } = this.state;
    return /*#__PURE__*/_jsxs("div", {
      "data-selenium": `${formDefinition.name}:accordions`,
      children: [/*#__PURE__*/_jsx(FormExpandableSection, {
        "data-selenium": "form-expandable-section-content",
        flush: flush,
        onOpenChange: this.onFormContentOpenChange,
        open: Boolean(this.state.formContentOpen),
        label: I18n.text(inlineEditingI18nKey('formContent.label')),
        useOnDark: useOnDark,
        children: /*#__PURE__*/_jsx(FormContent, {
          DraggableComponents: DraggableComponents,
          formGuid: this.formGuid,
          useOnDark: useOnDark,
          formDefinition: formDefinition,
          formFields: formDefinition.getFields(),
          buttonText: formDefinition.getSubmitText(),
          isCaptchaEnabled: formDefinition.getIsCaptchaEnabled(),
          canChangeFieldsOrder: Boolean(allowFormEditingDnd && formDefinition.canUpdateFormFieldsOrder()),
          gdprValue: formDefinition.getGdprConsentType(),
          isGdprSelectDisabled: !consentCopy,
          onButtonTextChange: submitText => this.updateForm(formDefinition.setSubmitText(submitText)),
          onIsCaptchaEnabledChange: captchaValue => this.updateForm(formDefinition.setIsCaptchaEnabled(captchaValue)),
          onRemoveFieldClick: id => {
            this.props.onRemoveFormFieldEvent();
            this.updateForm(formDefinition.removeFormFieldById(id));
          },
          onAddFieldClick: property => {
            this.props.onAddFormFieldEvent();
            this.updateForm(formDefinition.addFormField({
              property
            }));
          },
          onChangeFieldsOrder: updatedOrder => {
            this.props.onReorderFieldsEvent();
            this.updateForm(formDefinition.updateFormFieldsOrder(updatedOrder));
          },
          onEditFieldClick: this.onEditField,
          onGdprValueChange: this.handleGdprValueChange,
          openFormFn: openFormFn,
          hasFormsWriteAccess: hasFormsWriteAccess,
          readOnly: readOnly
        })
      }), /*#__PURE__*/_jsx(FormExpandableSection, {
        "data-selenium": "form-expandable-section-thankyou",
        flush: flush,
        onOpenChange: this.onThankYouOpenChange,
        open: this.state.thankYouOpen,
        label: I18n.text(inlineEditingI18nKey('thankYou.label')),
        useOnDark: useOnDark,
        children: this.renderResponse()
      }), /*#__PURE__*/_jsx(FormAutomationFieldGroup, {
        willScrollAfterRemount: willScrollAfterRemount,
        resetWillScrollAfterRemount: resetWillScrollAfterRemount,
        stretchToSides: !flush,
        fieldGroupOpen: formAutomationOpen,
        onFieldGroupOpenChange: onFormAutomationOpenChange,
        children: /*#__PURE__*/_jsx(FormAutomation, {
          contentId: contentId,
          followupEmailId: value.followup_email_id,
          formGuid: value.form_id,
          formName: formDefinition.name,
          legacyFollowupEmailId: legacyFollowupEmailId,
          clearLegacyFollowupEmail: clearLegacyFollowupEmail,
          alwaysCreateContactForNewEmail: formDefinition.getAlwaysCreateContactForNewEmail(),
          onAlwaysCreateContactForNewEmailChange: newContactsValue => {
            onAutomationChange();
            this.updateForm(formDefinition.setAlwaysCreateContactForNewEmail(newContactsValue));
          },
          shouldShowMarketingContactsToggle: hasMarketingContactsAccess,
          hasMarketingContactsPermissions: hasMarketingContactsPermissions,
          isCreatingMarketingContacts: formDefinition.getIsCreatingMarketingContacts(),
          onIsCreatingMarketingContactsChange: newValue => {
            onAutomationChange();
            onIsCreatingMarketingContactsChange(newValue);
            this.updateForm(formDefinition.setIsCreatingMarketingContacts(newValue));
          },
          readOnly: readOnly,
          hasAutomatedEmailEditorAccess: hasAutomatedEmailEditorAccess,
          hasEmailMarketingAccess: hasEmailMarketingAccess,
          hasFormsWriteAccess: hasFormsWriteAccess,
          hasInlineEmailEditorAccess: hasInlineEmailEditorAccess,
          hasWorkflowsAccess: hasWorkflowsAccess,
          hasWorkflowsAppAccess: hasWorkflowsAppAccess,
          hasWorkflowsDeleteAccess: hasWorkflowsDeleteAccess,
          hasWorkflowsWriteAccess: hasWorkflowsWriteAccess,
          isFreePortal: isFreePortal,
          onAddWorkflowEvent: onAddWorkflowEvent,
          onEditWorkflowEvent: onEditWorkflowEvent,
          onRemoveWorkflowEvent: onRemoveWorkflowEvent,
          onChangeFollowupEmailEvent: onChangeFollowupEmailEvent,
          onFollowupEmailIdChange: onFollowupEmailIdChange,
          scrollToFollowupEmail: scrollToFollowupEmail,
          followupEmailSelectedForForm: followupEmailSelectedForForm,
          webinarSelect: webinarSelect
        })
      })]
    });
  }
  render() {
    const {
      defaultFormNamePrefix,
      extraDropdownFooterContent,
      onFormChange,
      value,
      rawHtmlEnabled,
      hasFormsWriteAccess,
      hasMarketingContactsAccess,
      hideFormSelector,
      clearCache,
      defaultOptions,
      dropdownFooter,
      error,
      readOnly,
      saveCache,
      useOnDark
    } = this.props;
    const {
      formDefinition,
      pagesSidePanelOpen,
      isShowingFormCreateModal,
      isCreateFormConflictError,
      isShowingFormCloneModal
    } = this.state;
    if (this.state.selectedFieldId) {
      return this.renderSelectedField();
    }
    const formSelectorSelectProps = {
      fieldKey: this.fieldKey,
      rawHtmlEnabled,
      debouncedLoadOptions: this.debouncedLoadOptions,
      clearCache,
      defaultOptions,
      dropdownFooter,
      error,
      readOnly,
      saveCache,
      useOnDark
    };
    return /*#__PURE__*/_jsxs("div", {
      "data-selenium": "form-with-inline-editing",
      "data-test-id": "form-with-inline-editing",
      children: [this.maybeRenderPagesModal(), !hideFormSelector && /*#__PURE__*/_jsx(FormSelectorSelect, Object.assign({}, formSelectorSelectProps, {
        value: value.form_id,
        onChange: onFormChange,
        dropdownFooter: /*#__PURE__*/_jsxs(TFlex, {
          direction: "column",
          children: [extraDropdownFooterContent, /*#__PURE__*/_jsx(CreateFormButton, {
            use: "link",
            onClick: this.showFormCreateModal,
            hasPermission: hasFormsWriteAccess
          })]
        })
      })), formDefinition && /*#__PURE__*/_jsx(TFlex, {
        justify: "end",
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(FormSaveIndicator, {
          form: formDefinition
        })
      }), !rawHtmlEnabled && formDefinition && /*#__PURE__*/_jsx(FormActionsDropdown, {
        guid: value.form_id,
        onCloneClick: this.toggleFormCloneModal,
        onEditorClick: this.props.openFormFn,
        onCreateClick: this.showFormCreateModal,
        onPagesClick: this.onShowPagesStateChange,
        onViewSubmissionsClick: this.props.openSubmissionsFn,
        hasFormsWriteAccess: hasFormsWriteAccess
      }), !this.formGuid && /*#__PURE__*/_jsx(View, {
        marginBlockStart: "200",
        as: "div",
        children: /*#__PURE__*/_jsx(CreateFormButton, {
          onClick: this.showFormCreateModal,
          hasPermission: hasFormsWriteAccess
        })
      }), hasMarketingContactsAccess && formDefinition && /*#__PURE__*/_jsx(MarketingContactsWarning, {
        enabled: formDefinition.getIsCreatingMarketingContacts()
      }), formDefinition && this.renderAccordions(), pagesSidePanelOpen && /*#__PURE__*/_jsx(PagesSidePanelContainer, {
        formGuid: this.formGuid,
        onClose: this.onShowPagesStateChange
      }), isShowingFormCreateModal && /*#__PURE__*/_jsx(CreateFormWithNameModal, {
        defaultFormNamePrefix: defaultFormNamePrefix,
        isConflictError: isCreateFormConflictError,
        onCancelClick: this.hideFormCreateModal,
        onCreateClick: this.handleCreateForm,
        headerText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('heading')
        }),
        createText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('create')
        })
      }), isShowingFormCloneModal && /*#__PURE__*/_jsx(CreateFormWithNameModal, {
        defaultFormNamePrefix: defaultFormNamePrefix,
        onCancelClick: this.toggleFormCloneModal,
        onCreateClick: this.handleCloneForm,
        isCreating: this.state.isClonePending,
        headerText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('cloneForm.heading')
        }),
        createText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('cloneForm.clone')
        })
      })]
    });
  }
}
FormWithInlineEditing.defaultProps = {
  defaultOptions: [],
  fieldKey: [],
  forms: {},
  pages: {},
  readOnly: false,
  value: {
    response_type: 'inline',
    message: ''
  },
  updatePreview: () => {}
};
export default connector(FormWithInlineEditing);